(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/checkbox.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/checkbox.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (components_checkbox)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }

  const Checkbox = _ref => {
    let _ref$name = _ref.name,
      name = _ref$name === void 0 ? "checkbox-".concat(Math.random(), "[]") : _ref$name,
      value = _ref.value,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "checkbox_".concat(name, "_").concat(value !== null && value !== void 0 ? value : Math.random()) : _ref$id,
      labelProps = _ref.labelProps,
      data = _ref.data,
      branding = _ref.branding,
      classes = _ref.classes,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      inline = _ref.inline,
      minWidth = _ref.minWidth,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      children = _ref.children,
      _ref$noLabel = _ref.noLabel,
      noLabel = _ref$noLabel === void 0 ? false : _ref$noLabel;
    const dataAttributes = {};
    if (data) {
      data.forEach(data => {
        dataAttributes["data-".concat(data.key)] = data.value;
      });
    }
    const inputClasses = ['form-toggle-input', 'form-toggle-checkbox'];
    if (branding) {
      inputClasses.push("form-toggle-".concat(branding));
    } else {
      inputClasses.push('form-toggle-default');
    }
    if (classes) {
      inputClasses.push(classes);
    }
    if (className) {
      inputClasses.push(className);
    }
    return React.createElement("div", _extends({
      className: "form-toggle ".concat(inline ? 'form-toggle-inline' : '')
    }, minWidth ? {
      style: {
        minWidth
      }
    } : {}), React.createElement("input", _extends({
      checked: checked,
      className: inputClasses.join(' '),
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      name: name,
      onChange: onChange,
      type: "checkbox",
      value: value
    }, dataAttributes)), !noLabel && React.createElement(external_svs_ui_ReactForm_namespaceObject.Label, _extends({}, labelProps, {
      id: id,
      isButton: true
    }), children));
  };
  Checkbox.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "Checkbox",
    "props": {
      "name": {
        "defaultValue": {
          "value": "`checkbox-${Math.random()}[]`",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "id": {
        "defaultValue": {
          "value": "`checkbox_${name}_${value ?? Math.random()}`",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "noLabel": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "branding": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "checked": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "classes": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "data": {
        "description": "",
        "type": {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "key": {
                "name": "string",
                "required": false
              },
              "value": {
                "name": "string",
                "required": false
              }
            }
          }
        },
        "required": false
      },
      "defaultChecked": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "disabled": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "inline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "labelProps": {
        "description": "",
        "type": {
          "name": "shape",
          "value": {
            "alignRight": {
              "name": "bool",
              "required": false
            },
            "centeredLabel": {
              "name": "bool",
              "required": false
            },
            "classes": {
              "name": "string",
              "required": false
            }
          }
        },
        "required": false
      },
      "minWidth": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "number"
          }, {
            "name": "string"
          }]
        },
        "required": false
      }
    }
  };
  const components_checkbox = Checkbox;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Checkbox = __webpack_exports__["default"];
})();

 })(window);